<span class="brn-checkmark" [ngClass]="{ checked: checked,
   'add--nft': name === 'add--nft','affiliates-approve': name === 'affiliates-approve',
   'affiliates-deny': name === 'affiliates-deny', 'disabled': name === 'disabled', error: error }">
  <i *ngIf="!error" class="material-icons"> check </i>
  <i *ngIf="error" class="material-icons"> close </i>
</span>
